import { render, staticRenderFns } from "./sense.vue?vue&type=template&id=7196b770&scoped=true"
import script from "./sense.vue?vue&type=script&lang=js"
export * from "./sense.vue?vue&type=script&lang=js"
import style0 from "./sense.vue?vue&type=style&index=0&id=7196b770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196b770",
  null
  
)

export default component.exports